import { PREFERRED_SITE_COOKIE } from "@/lib/site/site-routing";
import { ApiError, apiFetch } from "@/lib/api-client";

export const PREFERRED_SITE_CHANGED_EVENT = "cms:preferred-site-changed";

const PREFERRED_SITE_MAX_AGE = 60 * 60 * 24 * 365;

export function readPreferredSite(): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  const match = new RegExp(`(?:^|;\\s*)${PREFERRED_SITE_COOKIE}=([^;]*)`).exec(document.cookie);

  return match ? decodeURIComponent(match[1]!) : null;
}

export function rememberPreferredSite(code: string): void {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${PREFERRED_SITE_COOKIE}=${encodeURIComponent(code)}; path=/; max-age=${PREFERRED_SITE_MAX_AGE}; SameSite=Lax`;
  window.dispatchEvent(new Event(PREFERRED_SITE_CHANGED_EVENT));
}

export async function savePreferredSite(code: string): Promise<void> {
  try {
    await apiFetch("/api/member/preferences", { method: "PATCH", body: { site: code } });
  } catch (error) {
    if (!(error instanceof ApiError && error.code === "UNAUTHORIZED")) throw error;
  }
  rememberPreferredSite(code);
}
